/** @fileoverview Header for the student "My tasks" page (title + subtitle + link to the tracker). */

import { Button, Group, Stack, Text, Title } from '@mantine/core'
import { IconChecklist } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { STUDENT_TASK_TRACKER_PATH } from 'pages/StudentTaskTracker'

const LINK_ICON_SIZE = 16

export function StudentTasksHeader() {
  const { t } = useTranslation()

  return (
    <Group position='apart' align='flex-start'>
      <Stack spacing={4}>
        <Title order={1}>{t('student_tasks.title')}</Title>
        <Text color='dimmed'>{t('student_tasks.description')}</Text>
      </Stack>
      {/* AR-898: entry point to the student's Tasks Tracker. */}
      <Button
        component={Link}
        to={STUDENT_TASK_TRACKER_PATH}
        variant='light'
        size='sm'
        leftIcon={<IconChecklist size={LINK_ICON_SIZE} />}
      >
        {t('student_task_tracker.my_tasks_link')}
      </Button>
    </Group>
  )
}
